import enviro from 'enviro';
import { gate } from 'hub-http/gates';
const GOOGLE_SHEETS_APP_IDS = {
  QA: 1265780,
  PROD: 228553
};
export const GOOGLE_SHEETS_APP_ID = enviro.isQa() ? GOOGLE_SHEETS_APP_IDS.QA : GOOGLE_SHEETS_APP_IDS.PROD;
export const GOOGLE_SHEETS_UA_REGISTER_ACCOUNT = gate('GoogleSheetsIntegration::UARegisterAccountGate');